import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > *:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg * {
    width: 24px;
    height: 24px;
  }
`;
